import firebase from '../../src/config/firebase';
require('firebase/auth')

const productService = {

    async postProduct(dados) {
        const response = await firebase.firestore().collection('product').add(dados);
        return response;
    },

    async getProductByID(id) {
        const snapshot = await firebase.firestore().collection('product').doc(id).get();
        if (snapshot.exists) {
            return snapshot;
        }
        else {
            return null;
        }
    },

    async getProduct() {
        const snapshot = await firebase.firestore()
            .collection("product")
            .get();

        if (snapshot.empty) return [];

        return snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    },

    async deleteProduct(id) {
        await firebase.firestore().collection('product').doc(id).delete();
    },

    async updateProduct(id, dados) {
        await firebase.firestore().collection('product').doc(id).update(dados);
    }
}

export default productService;